import { Component, OnInit } from '@angular/core';
import { CiacService } from 'src/app/services/http/ciac.service';
import { Router } from '@angular/router';
import { ModalMsgService } from 'src/app/services/modal-msg.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalJustificativaComponent } from 'src/app/app-components/modal-justificativa/modal-justificativa.component';

@Component({
  selector: 'app-lista-fornecedores-ciac',
  templateUrl: './lista-fornecedores-ciac.component.html',
  styleUrls: ['./lista-fornecedores-ciac.component.scss']
})
export class ListaFornecedoresCiacComponent implements OnInit {

  sorting: { 
    id: "asc",
    nome: "",
  }

  filter = {
    sorting: { 
      id: "asc",
      nome: ""
    },
    filter: {
      nome: ""
    },
    data: new Date(),
    page: 1,
    per_page: 10,
  };

  total:number = 0;
  tableLoading = true;
  listaFornecedor = [{ id: 0, nome: 'Teste', cnpj: '000.000.000/0001-00' }];

  constructor(private ciacService: CiacService, private router: Router, private modalMsgService: ModalMsgService, private modalService: NgbModal) { }

  ngOnInit() {
    this.listaFornecedores();
  }

  listaFornecedores() {
    this.filter.sorting = this.removeEmpty({ ...this.sorting });
    let dataUpdate = this.filter.data;
    this.ciacService.getListaFornecedores(this.filter).then(c => {
      if(dataUpdate == this.filter.data) {
        this.tableLoading = false;
        this.total = c.total || 0;
        this.listaFornecedor = this.listaFornecedor.concat(c.lista) || [];
      }
    });
    if(this.listaFornecedor.length == 0) {
      this.tableLoading = false;
    }
  }

  removeEmpty(obj) {
    this.listaFornecedor = [];
    Object.keys(obj).forEach((key) => (obj[key] == '') && delete obj[key]);
    return obj;
  }

  setPageSize(pageSize) {
    this.filter.page = 1;
    this.filter.per_page = pageSize;
    this.listaFornecedores();
  }

  nextPage() {
    this.listaFornecedores();
  }

  editFornecedor(id) {
    this.router.navigate(['ciac', 'fornecedores', 'editar', id]);
  }

  delFornecedor(id) {
    let params = {
      id: parseInt(id)
    }
    const modalRef = this.modalService.open(ModalJustificativaComponent, { centered: true });
    modalRef.componentInstance.cabecalho = 'Remover Fornecedor';
    modalRef.result.then(justificativa => {
      if (justificativa) {
        this.ciacService.delFornecedorCiac(justificativa, params)
          .then(r => this.listaFornecedores())
          .catch(e => this.modalMsgService.openDialog('Erro ao remover fornecedor', '', 'danger'));
      } else {
        this.modalMsgService.openDialog('Erro ao remover fornecedor',
          'Informe uma Justificativa para concluir a operação', 'danger');
      }
    }).catch(e => this.modalMsgService.openDialog('Erro ao remover fornecedor',
      'Informe uma Justificativa para concluir a operação', 'danger'));
  }

}
